import { Dispatch, FC, SetStateAction } from 'react'
import LabelsShowMode from './LabelsShowMode'
import CreateLabels from './CreateLabels'
import {
  CPIFrequency,
  CustomLabelCountI,
  CustomLabelDate,
  CustomLabelsDataPayload,
  CustomLabelsListI,
  DateRangeI,
  VisibleLabel
} from 'models'
import { Dayjs } from 'dayjs'

interface Props {
  mode: string
  setLoading: Dispatch<SetStateAction<boolean>>
  customLabels: CustomLabelsListI
  customLabelsCount: CustomLabelCountI
  updateEditLabel: (label: any) => void
  updateMode: (newMode: string) => void
  updateLabels: (payload?: CustomLabelsDataPayload, ignoreCustomPeriod?: boolean) => Promise<void>
  updateLabelsAfterMutation: (payload?: CustomLabelsDataPayload, ignoreCustomPeriod?: boolean) => Promise<void>
  loading: boolean
  customDate: CustomLabelDate
  unpinLabel: (labelId: string) => Promise<void>
  pinLabel: (labelId: string) => Promise<void>
  visibleLabels: VisibleLabel[]
  setVisibleLabels: Dispatch<SetStateAction<VisibleLabel[]>>
  pinningLabel: boolean
  setPinningLabel: Dispatch<SetStateAction<boolean>>
  selectedFrequency: CPIFrequency
  redirectToMode: string
  cpiName: string | undefined
  cpiConfId: string | undefined
  dateRange: DateRangeI
  returnToZero: () => void
  selectedDateRange: [Dayjs | null, Dayjs | null]
  setSelectedDateRange: (newRange: [Dayjs | null, Dayjs | null]) => void
  deleteLabelCallback?: (labelId: string) => void
}

const LabelsDrawerContent: FC<Props> = ({
  mode,
  setLoading,
  loading,
  customLabels,
  customLabelsCount,
  updateEditLabel,
  updateLabels,
  updateLabelsAfterMutation,
  customDate,
  unpinLabel,
  pinLabel,
  visibleLabels,
  setVisibleLabels,
  pinningLabel,
  setPinningLabel,
  // selectedFrequency,
  redirectToMode,
  cpiName,
  cpiConfId,
  dateRange,
  updateMode,
  returnToZero,
  selectedDateRange,
  setSelectedDateRange,
  deleteLabelCallback
}) => {
  if (mode?.includes('show')) {
    return (
      <LabelsShowMode
        mode={mode}
        setLoading={setLoading}
        loading={loading}
        updateMode={updateMode}
        customLabels={customLabels}
        customLabelsCount={customLabelsCount}
        updateEditLabel={updateEditLabel}
        updateLabels={updateLabels}
        customDate={customDate}
        unpinLabel={unpinLabel}
        pinLabel={pinLabel}
        visibleLabels={visibleLabels}
        setVisibleLabels={setVisibleLabels}
        pinningLabel={pinningLabel}
        setPinningLabel={setPinningLabel}
        dateRange={dateRange}
        selectedDateRange={selectedDateRange}
        setSelectedDateRange={setSelectedDateRange}
      />
    )
  }
  if (mode === 'create' || mode === 'edit' || mode === 'delete') {
    return (
      <CreateLabels
        mode={mode}
        redirectToMode={redirectToMode}
        setLoading={setLoading}
        cpiName={cpiName}
        customDate={customDate}
        cpiConfId={cpiConfId}
        updateMode={updateMode}
        updateLabels={updateLabelsAfterMutation}
        returnToZero={returnToZero}
        dateRange={dateRange}
        deleteLabelCallback={deleteLabelCallback}
      />
    )
  }

  return null
}

export default LabelsDrawerContent
